import { Link } from 'react-router-dom';
import { navLinks, site } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-plant-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-secondary-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              {site.description}
            </p>
            <a
              href={`mailto:${site.email}`}
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm text-secondary-100 transition-colors hover:text-primary-300"
            >
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-800">
                <i className="ri-mail-line"></i>
              </span>
              {site.email}
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-secondary-50">
              <Link to="/" className="cursor-pointer transition-colors hover:text-primary-300">
                站内导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {navLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer text-secondary-200 transition-colors hover:text-primary-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-secondary-50">
              <Link to="/topics" className="cursor-pointer transition-colors hover:text-primary-300">
                内容方向
              </Link>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
              {categories.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/topics?category=${item.id}`}
                    className="cursor-pointer text-secondary-200 transition-colors hover:text-primary-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {site.name} · 内容仅供阅读参考，欢迎核对原始来源后再转发。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="whitespace-nowrap">理性吃瓜 · 拒绝拼接信息</span>
            <a href={`mailto:${site.submitEmail}`} className="cursor-pointer whitespace-nowrap hover:text-primary-300">
              线索投稿
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}